<template>
  <div>
    <div class="mt-4 mb-4 pl-2">
      <div class="form-group row" v-for="(value, key) in cashLists" :key="key">

        <div class="col-lg-4 turn-center pl-4" v-if="(value.enable && value.game_coin)">
          <label class="text-success">{{ value.name }}</label>
        </div>
        <div class="col-lg-4 text-center" v-if="(value.enable && value.game_coin)">
          <strong class="text-danger">{{ Helper.formatMoney(userBalance[key]) }}</strong>
        </div>

        <div class="col-lg-4 text-center" v-if="(value.enable && value.game_coin)">
          <button type="button" class="btn btn-fill-out btn-sm" data-bs-toggle="modal" data-bs-target="#withdraw" data-toggle="modal" data-target="#withdraw" @click="getSelectedCash(key)">
            Rút về game
          </button>
        </div>
      </div>
    </div>

      <!-- Modal -->
      <div class="modal fade" id="withdraw" tabindex="-1" role="dialog" aria-labelledby="withdrawLolRpLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="withdrawLolRpLabel">{{ selectedCash.name }}</h5>
              <button type="button" class="close" data-bs-dismiss="modal" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <h5 class="text-success">
                Bạn đang sở hữu: <strong class="text-danger">{{ Helper.formatMoney(userBalance[cashType]) }} <sup>{{ selectedCash.unit == 'Diamond' ? 'Kim Cương' : selectedCash.unit
                }}</sup></strong>
              </h5>

              <form>
                <div class="form-group" id="withdraw">
                  <label for="rp-value" class="col-form-label">Chọn hạn mức rút:</label>
                  <select class="form-control" id="rp-value" name="value" v-model="form['value']">
                    <option :value="value" v-for="(value, key) in selectedCash.limits" :key="key">{{ value }} {{ selectedCash.unit == 'Diamond' ? 'Kim Cương' : selectedCash.unit }}</option>
                  </select>
                </div>

                <div class="form-group" v-for="(value, key) in selectedCash.fields"  :key="key">
                  <label for="rp-username" class="col-form-label">{{ value['label'] }}:</label>
                  <input :type="value['type']" v-model="form[value['name']]" class="form-control" :id="value['name']"
                         :name="value['name']">
                </div>

              </form>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" data-dismiss="modal">Đóng</button>
              <button id="rp-submit" type="submit" @click="submit()" class="btn btn-danger">Rút Quà</button>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  props: {
    user: {
      Type: Object,
      default() {
        return {};
      }
    },
    userBalance: {
      Type: Number,
      default() {
        return 0;
      }
    },
    website: {
      Type: Object,
      default() {
        return {};
      }
    },
    cashLists: {
      Type: Object,
      default() {
        return {};
      }
    },

  },

  data() {
    return {
      form: [],
      selectedCash : {},
      cashType: 'together_gem'
    }
  },
  methods: {
    getSelectedCash(key){
      this.cashType = key;
      this.selectedCash = this.cashLists[this.cashType]
    },
    async withdraw() {
      try {
        const uri = this.route('withdraw', {domain: this.website.domain});

        let postData =  {
          username : this.form.username,
          password : this.form.password,
          phone : this.form.phone ?? '',
          value : this.form.value ?? 0,
          nickname: this.form.nickname ?? '',
          login_code: this.form.login_code ?? '',
          type: this.cashType
        }

        console.log(postData)

        const response = await this.Request.post(uri, postData);

        if (response.data.result === false) {
          await this.$swal.fire({
            title: 'Có lỗi xảy ra!',
            text: response.data.msg,
            icon: 'error'
          });
        } else {
          await this.$swal.fire({
                icon: 'success',
                title: 'Thành Công',
                html: response.data.msg,
              }
          );

          location.reload();
        }
      } catch (e) {
        console.log(e); // eslint-disable-line
        const errorMessages = this.Request.errors(e.response);
        await this.$swal({
          icon: 'error',
          title: 'Error',
          text: this._.isEmpty(errorMessages) ? e.response.data.error : errorMessages[0],
        });
      }
    },
    async submit() {
      await this.$swal.fire({
        title: 'Xác nhận rút quà!',
        text: "Bạn có chắc muốn rút quà?",
        showCancelButton: true,
        confirmButtonText: `OK`,
        cancelButtonText: `Huỷ`,
      }).then((result) => {
        if (result.isConfirmed) {
          this.withdraw();
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
